import type { CorpusScanHeading, CorpusScanKey } from "./corpus_scan_contract";

/** Every scan in the order its card appears, with the title and one-line description of both. */
export const CORPUS_SCAN_HEADINGS: Record<CorpusScanKey, CorpusScanHeading> = {
  missing_field: {
    title: "Missing field",
    description: "Documents with no label for a field you choose.",
  },
  missing_section_files: {
    title: "Missing section files",
    description: "Documents whose section files are gone from Storage.",
  },
};

export const CORPUS_SCAN_KEYS = Object.keys(CORPUS_SCAN_HEADINGS) as CorpusScanKey[];
